/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Audit category information
 * @export
 * @interface AuditCategoryInfo
 */
export interface AuditCategoryInfo {
    /**
     * Category name
     * @type {string}
     * @memberof AuditCategoryInfo
     */
    name?: string;
    /**
     * Category display name
     * @type {string}
     * @memberof AuditCategoryInfo
     */
    displayName?: string;
    /**
     * Category description
     * @type {string}
     * @memberof AuditCategoryInfo
     */
    description?: string;
    /**
     * Example actions for this category
     * @type {Array<string>}
     * @memberof AuditCategoryInfo
     */
    examples?: Array<string>;
}

/**
 * Check if a given object implements the AuditCategoryInfo interface.
 */
export function instanceOfAuditCategoryInfo(value: object): value is AuditCategoryInfo {
    return true;
}

export function AuditCategoryInfoFromJSON(json: any): AuditCategoryInfo {
    return AuditCategoryInfoFromJSONTyped(json, false);
}

export function AuditCategoryInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditCategoryInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'description': json['description'] == null ? undefined : json['description'],
        'examples': json['examples'] == null ? undefined : json['examples'],
    };
}

export function AuditCategoryInfoToJSON(json: any): AuditCategoryInfo {
    return AuditCategoryInfoToJSONTyped(json, false);
}

export function AuditCategoryInfoToJSONTyped(value?: AuditCategoryInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'displayName': value['displayName'],
        'description': value['description'],
        'examples': value['examples'],
    };
}

